import { render } from "./StyleguideModalConfirm.pug?vue&type=template&id=26a6f03a&lang=pug"
import script from "./StyleguideModalConfirm.js?vue&type=script&lang=js"
export * from "./StyleguideModalConfirm.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__